(() => {
  const SELECTOR = '.template-index .brands-slider, .template-index [data-brands-slider]';
  const start = () => {
    document.querySelectorAll(SELECTOR).forEach((rail) => {
      if (rail.dataset.am2pmAuto === 'true') return;
      rail.dataset.am2pmAuto = 'true';
      window.setInterval(() => {
        if (document.hidden || rail.matches(':hover')) return;
        const item = rail.querySelector('.brand-item, .halo-item, li');
        const step = item ? item.getBoundingClientRect().width + 16 : rail.clientWidth / 5;
        const end = rail.scrollWidth - rail.clientWidth - 4;
        rail.scrollTo({ left: rail.scrollLeft >= end ? 0 : rail.scrollLeft + step, behavior: 'smooth' });
      }, 2000);
    });
  };
  document.addEventListener('DOMContentLoaded', start, { once: true });
  document.addEventListener('shopify:section:load', start);
})();

(() => {
  const SELECTOR = '#halo-cart-sidebar .halo-sidebar-wrapper, .halo-edit-cart-popup .halo-popup-content, #amazon-slide-drawer .amazon-drawer-content, #amazon-slide-drawer.is-split .amazon-drawer-panel-sub';
  let current = null;
  const setCurrent = (el) => {
    if (el === current) return;
    if (current) current.classList.remove('is-scroll-hover');
    current = el;
    if (current) current.classList.add('is-scroll-hover');
  };
  const overScrollbar = (el, x) => {
    const style = getComputedStyle(el);
    const left = parseFloat(style.borderLeftWidth) || 0;
    const right = parseFloat(style.borderRightWidth) || 0;
    const bar = el.offsetWidth - el.clientWidth - left - right;
    if (bar <= 0) return false;
    const rect = el.getBoundingClientRect();
    if (style.direction === 'rtl') return x >= rect.left + left && x <= rect.left + left + bar;
    return x <= rect.right - right && x >= rect.right - right - bar;
  };
  document.addEventListener('pointermove', (event) => {
    if (event.pointerType && event.pointerType !== 'mouse') return;
    const el = event.target.closest ? event.target.closest(SELECTOR) : null;
    setCurrent(el && overScrollbar(el, event.clientX) ? el : null);
  }, { passive: true });
  document.addEventListener('pointerout', (event) => {
    if (!event.relatedTarget) setCurrent(null);
  });
})();

(() => {
  const popup = document.querySelector('.halo-edit-cart-popup');
  if (!popup) return;
  const snap = (box) => {
    const media = box.querySelector('.product-edit-image');
    if (!media) return;
    const height = Math.floor(media.getBoundingClientRect().height);
    const value = height > 0 ? height + 'px' : '';
    if (box.style.height !== value) box.style.height = value;
  };
  const resize = 'ResizeObserver' in window ? new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      const box = entry.target.closest('.am2pm-edit-main, .product-edit-itemLeft');
      if (box) snap(box);
    });
  }) : null;
  const observed = new WeakSet();
  const watch = () => {
    popup.querySelectorAll('.product-edit-itemLeft').forEach((left) => {
      const box = left.querySelector('.am2pm-edit-main') || left;
      const media = box.querySelector('.product-edit-image');
      if (media && resize && !observed.has(media)) {
        observed.add(media);
        resize.observe(media);
      }
      snap(box);
    });
  };
  new MutationObserver(watch).observe(popup, { childList: true, subtree: true });
  watch();
})();

(() => {
  const MEDIA = '.halo-edit-cart-popup .product-edit-image';
  const ACTIVE = 'is-am2pm-zoomed';
  const enabled = () => window.matchMedia('(min-width: 1025px) and (hover: hover) and (pointer: fine)').matches;
  const zoomUrl = (img) => {
    const src = img && (img.currentSrc || img.src);
    if (!src) return '';
    try {
      const url = new URL(src, window.location.href);
      url.pathname = url.pathname.replace(/_(\d+x\d*|\d*x\d+)(?=\.[a-z0-9]+$)/i, '');
      url.searchParams.set('width', '1500');
      return url.href;
    } catch (error) {
      return src;
    }
  };
  const move = (media, event) => {
    const layer = media.querySelector('.am2pm-zoom-layer');
    const rect = media.getBoundingClientRect();
    if (!layer || !rect.width || !rect.height) return;
    const x = Math.min(Math.max((event.clientX - rect.left) / rect.width, 0), 1);
    const y = Math.min(Math.max((event.clientY - rect.top) / rect.height, 0), 1);
    layer.style.transformOrigin = (x * 100) + '% ' + (y * 100) + '%';
  };
  const activate = (media, event) => {
    const url = zoomUrl(media.querySelector('img:not(.am2pm-zoom-layer)'));
    if (!url) return;
    let layer = media.querySelector('.am2pm-zoom-layer');
    if (!layer) {
      layer = document.createElement('img');
      layer.className = 'am2pm-zoom-layer';
      layer.alt = '';
      layer.setAttribute('aria-hidden', 'true');
      media.appendChild(layer);
    }
    if (layer.getAttribute('data-src') !== url) {
      layer.setAttribute('data-src', url);
      layer.src = url;
    }
    move(media, event);
    media.classList.add(ACTIVE);
  };
  document.addEventListener('mouseover', (event) => {
    if (!event.target.closest) return;
    const media = event.target.closest(MEDIA);
    document.querySelectorAll(MEDIA + '.' + ACTIVE).forEach((other) => {
      if (other !== media) other.classList.remove(ACTIVE);
    });
    if (media && enabled()) activate(media, event);
  }, true);
  document.addEventListener('mousemove', (event) => {
    if (!event.target.closest) return;
    const media = event.target.closest(MEDIA);
    if (media && media.classList.contains(ACTIVE)) move(media, event);
  }, { capture: true, passive: true });
  document.addEventListener('mouseout', (event) => {
    if (!event.target.closest) return;
    const media = event.target.closest(MEDIA);
    if (media && !media.contains(event.relatedTarget)) media.classList.remove(ACTIVE);
  }, true);
  document.addEventListener('click', (event) => {
    if (!event.target.closest) return;
    const media = event.target.closest(MEDIA);
    if (!media || !media.getAttribute('href')) return;
    const item = media.closest('.product-edit-item') || media.closest('.halo-edit-cart-popup');
    const input = item && (item.querySelector('form input[name="id"]') || document.querySelector('.halo-edit-cart-popup form input[name="id"]'));
    try {
      const url = new URL(media.getAttribute('href'), window.location.href);
      if (input && input.value) url.searchParams.set('variant', input.value);
      media.setAttribute('href', url.pathname + url.search);
    } catch (error) {}
  }, true);
})();

(() => {
  const popup = document.querySelector('.halo-edit-cart-popup');
  if (!popup) return;
  const key = (src) => {
    if (!src) return '';
    const file = src.split('?')[0].split('/').pop() || '';
    return file.replace(/_(\d+x\d*|\d*x\d+)(?=\.[a-z0-9]+$)/i, '').replace(/\.[a-z0-9]+$/i, '');
  };
  const parts = (el) => {
    const left = el.closest('.product-edit-itemLeft');
    if (!left) return null;
    const main = left.querySelector('.product-edit-image img:not(.am2pm-zoom-layer)');
    const strip = left.querySelector('[data-am2pm-edit-thumbs]');
    const thumbs = strip ? Array.from(strip.querySelectorAll('[data-am2pm-edit-thumb]')) : [];
    return { main, strip, thumbs };
  };
  const reveal = (strip, thumb) => {
    const left = thumb.offsetLeft - strip.offsetLeft;
    if (left < strip.scrollLeft || left + thumb.offsetWidth > strip.scrollLeft + strip.clientWidth) {
      strip.scrollLeft = left;
    }
  };
  const mark = (p, active) => {
    p.thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb === active));
    if (active && p.strip) reveal(p.strip, active);
  };
  const show = (p, thumb) => {
    if (!p.main || !thumb) return;
    const src = thumb.getAttribute('data-src');
    p.main.dataset.am2pmSkipSync = 'true';
    p.main.removeAttribute('srcset');
    p.main.setAttribute('src', src);
    mark(p, thumb);
  };
  popup.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-am2pm-edit-thumb]');
    const step = event.target.closest('[data-am2pm-edit-step]');
    if (!thumb && !step) return;
    event.preventDefault();
    const p = parts(thumb || step);
    if (!p || !p.thumbs.length) return;
    if (thumb) {
      show(p, thumb);
      return;
    }
    const current = Math.max(p.thumbs.findIndex((t) => t.classList.contains('is-active')), 0);
    const count = p.thumbs.length;
    const next = (current + Number(step.getAttribute('data-am2pm-edit-step')) + count) % count;
    show(p, p.thumbs[next]);
  });
  const sync = (img) => {
    if (img.dataset.am2pmSkipSync) {
      delete img.dataset.am2pmSkipSync;
      return;
    }
    const p = parts(img);
    if (!p || !p.thumbs.length) return;
    const k = key(img.getAttribute('src'));
    const match = p.thumbs.find((t) => key(t.getAttribute('data-src')) === k);
    if (match) mark(p, match);
  };
  new MutationObserver((records) => {
    records.forEach((record) => {
      const t = record.target;
      if (record.type === 'attributes' && t.matches && t.matches('.product-edit-image img:not(.am2pm-zoom-layer)')) sync(t);
    });
  }).observe(popup, { subtree: true, attributes: true, attributeFilter: ['src'] });
  new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (node.nodeType !== 1 || !node.matches('.product-edit-item') || node.classList.contains('product-edit-itemFirst')) return;
        const left = node.querySelector('.product-edit-itemLeft');
        const p = left && parts(left);
        if (!p || !p.thumbs.length) return;
        node.querySelectorAll('.product-edit-image.is-am2pm-zoomed').forEach((media) => media.classList.remove('is-am2pm-zoomed'));
        show(p, p.thumbs[0]);
        if (p.strip) p.strip.scrollLeft = 0;
      });
    });
  }).observe(popup, { subtree: true, childList: true });
})();

(() => {
  const popup = document.querySelector('.halo-edit-cart-popup');
  if (!popup) return;
  const pick = (list) => {
    const values = String(list || '').split(',').map((v) => v.trim()).filter(Boolean);
    return values.length ? values[Math.floor(Math.random() * values.length)] : '';
  };
  const reveal = () => {
    popup.querySelectorAll('[data-sold-out-product]').forEach((box) => {
      if (box.dataset.am2pmSold) return;
      const number = pick(box.dataset.item);
      const hours = pick(box.dataset.hours);
      if (!number || !hours) return;
      box.dataset.am2pmSold = 'true';
      const n = box.querySelector('[data-sold-out-number]');
      const h = box.querySelector('[data-sold-out-hours]');
      if (n) n.textContent = number;
      if (h) h.textContent = hours;
      box.style.display = '';
    });
  };
  new MutationObserver(reveal).observe(popup, { childList: true, subtree: true });
  reveal();
})();

(() => {
  const content = document.querySelector('.halo-edit-cart-popup .halo-popup-content');
  if (!content) return;
  let open = document.body.classList.contains('edit-cart-show');
  new MutationObserver(() => {
    const now = document.body.classList.contains('edit-cart-show');
    if (now && !open) content.scrollTop = 0;
    open = now;
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();

(() => {
  const popup = document.querySelector('.halo-edit-cart-popup');
  const content = popup && popup.querySelector('.halo-popup-content');
  const title = popup && popup.querySelector('[data-am2pm-edit-title]');
  if (!content || !title) return;
  let frame = 0;
  const update = () => {
    frame = 0;
    const items = content.querySelectorAll('.product-edit-item');
    const line = content.getBoundingClientRect().top + content.clientHeight * 0.35;
    let active = null;
    items.forEach((item) => {
      if (item.getBoundingClientRect().top <= line) active = item;
    });
    const more = !!active && !active.classList.contains('product-edit-itemFirst');
    const text = more ? title.dataset.moreTitle : title.dataset.title;
    if (title.textContent !== text) title.textContent = text;
    title.classList.toggle('is-more-title', more);
  };
  const queue = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  content.addEventListener('scroll', queue, { passive: true });
  new MutationObserver(queue).observe(content, { childList: true, subtree: true });
  new MutationObserver(queue).observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();

(() => {
  const scroller = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper');
  if (!scroller) return;
  let open = document.body.classList.contains('cart-sidebar-show');
  let saved = scroller.scrollTop;
  let guardUntil = 0;
  const guarding = () => Date.now() < guardUntil;
  const pinned = () => Date.now() < (scroller.am2pmPinUntil || 0);
  const restore = () => {
    if (pinned()) return;
    if (guarding() && Math.abs(scroller.scrollTop - saved) > 1) scroller.scrollTop = saved;
  };
  const guard = () => {
    guardUntil = Date.now() + 1500;
    restore();
    requestAnimationFrame(restore);
  };
  scroller.addEventListener('scroll', () => {
    if (!guarding() || pinned()) saved = scroller.scrollTop;
  }, { passive: true });
  ['wheel', 'touchmove', 'keydown', 'pointerdown'].forEach((type) => {
    scroller.addEventListener(type, () => {
      guardUntil = 0;
    }, { passive: true });
  });
  new MutationObserver(guard).observe(scroller, { childList: true, subtree: true });
  if (window.ResizeObserver) {
    const resize = new ResizeObserver(restore);
    const watch = () => Array.from(scroller.children).forEach((child) => resize.observe(child));
    watch();
    new MutationObserver(watch).observe(scroller, { childList: true });
  }
  new MutationObserver(() => {
    const now = document.body.classList.contains('cart-sidebar-show');
    if (now && !open) {
      saved = 0;
      scroller.scrollTop = 0;
      document.querySelectorAll('#halo-cart-sidebar .previewCart').forEach((el) => {
        el.scrollTop = 0;
      });
    }
    open = now;
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();

document.addEventListener('click', (event) => {
  const icon = event.target.closest && event.target.closest('[data-am2pm-notice-info-icon]');
  if (!icon) return;
  const toggle = icon.closest('[data-am2pm-notice-info]')?.querySelector('[data-shipping-info-toggle]');
  if (!toggle) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  toggle.click();
}, true);

(() => {
  const icon = '<svg viewBox="0 0 28 28" aria-hidden="true" focusable="false"><circle cx="14" cy="14" r="14"/><path d="M9.5 9.5l9 9M18.5 9.5l-9 9"/></svg>';
  const roots = [document.getElementById('halo-cart-sidebar')];
  if (document.body.classList.contains('template-cart')) roots.push(document.getElementById('MainContent') || document.body);
  const addButtons = () => {
    roots.forEach((root) => root && root.querySelectorAll('[data-shipping-info] .shippingInfo__popup').forEach((popup) => {
      if (popup.querySelector(':scope > .am2pm-info-close')) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'am2pm-info-close';
      button.setAttribute('aria-label', 'Schliessen');
      button.innerHTML = icon;
      popup.appendChild(button);
    }));
  };
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    Promise.resolve().then(() => {
      queued = false;
      addButtons();
    });
  });
  roots.forEach((root) => root && observer.observe(root, { childList: true, subtree: true }));
  addButtons();
  document.addEventListener('click', (event) => {
    const button = event.target.closest && event.target.closest('.am2pm-info-close');
    if (!button) return;
    const info = button.closest('[data-shipping-info]');
    if (!info) return;
    event.preventDefault();
    event.stopPropagation();
    info.classList.remove('is-open');
    const toggle = info.querySelector('[data-shipping-info-toggle]');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.blur();
    }
  }, true);
})();

(() => {
  const sidebar = document.getElementById('halo-cart-sidebar');
  if (!sidebar) return;
  const line = document.createElement('div');
  line.className = 'am2pm-summary-line-gutter';
  line.setAttribute('aria-hidden', 'true');
  sidebar.appendChild(line);
  let raf = null;
  const place = () => {
    raf = null;
    const scroller = sidebar.querySelector('.halo-sidebar-wrapper');
    const info = scroller && scroller.querySelector('.previewCartInfo');
    const gutter = scroller ? scroller.offsetWidth - scroller.clientWidth : 0;
    if (!info || !gutter || !document.body.classList.contains('cart-sidebar-show')) {
      line.style.display = 'none';
      return;
    }
    const style = getComputedStyle(info);
    const thickness = parseFloat(style.borderTopWidth) || 0;
    const box = sidebar.getBoundingClientRect();
    const view = scroller.getBoundingClientRect();
    const top = info.getBoundingClientRect().top;
    if (!thickness || top < view.top || top + thickness > view.bottom) {
      line.style.display = 'none';
      return;
    }
    line.style.display = 'block';
    line.style.left = (view.left - box.left) + 'px';
    line.style.width = gutter + 'px';
    line.style.top = (top - box.top) + 'px';
    line.style.height = thickness + 'px';
    line.style.backgroundColor = style.borderTopColor;
  };
  const queue = () => {
    if (!raf) raf = requestAnimationFrame(place);
  };
  sidebar.addEventListener('scroll', queue, true);
  window.addEventListener('resize', queue);
  new MutationObserver(queue).observe(sidebar, { childList: true, subtree: true });
  new MutationObserver(queue).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  sidebar.addEventListener('transitionend', queue);
  queue();
})();
